<script>
    import sustainabilityLabelClickTracker from "../tracking/sustainabilityLabelClickTracker";

    /**
 *
 *
 *
 *
 *
 */

    /*                */
    let { labels, cinemaId, variationId, cinemaTracking } = $props();

    const clickHandler = (labelTag) => {
        sustainabilityLabelClickTracker({
            variationId,
            cinemaType: cinemaTracking.name,
            sustainabilityTag: labelTag,
        });
    };
</script>

{#if Array.isArray(labels) && labels.length >= 1}
    <div class="reco_cinema__multi-sustainabilities-container oc-mt-50">
        {#each labels as label}
            {#if label.variant}
                <!-- svelte-ignore a11y_no_static_element_interactions a11y_click_events_have_key_events -->
                <ofc-sustainability-badge-v1
                    class="oc-mr-25"
                    as-button
                    data-testid="sustainability-badge-{label.variant}"
                    variant={label.variant}
                    data-oc-sheet-v1-create
                    data-oc-sheet-v1-create.id="reco_sustainability_sheet_{cinemaId}_{variationId}_{label.variant}"
                    data-oc-sheet-v1-create.url={label.descriptionUrl}
                    data-oc-sheet-v1-create.headline="Was bedeutet dieses Zeichen?"
                    onclick={clickHandler(label.tag)}
                ></ofc-sustainability-badge-v1>
            {/if}
        {/each}
    </div>
{/if}

<style lang="scss">
    .reco_cinema__multi-sustainabilities-container {
        display: flex;
        flex-wrap: wrap;
    }
</style>
